import styled from 'styled-components';
import { DeprecatedGrid as Grid } from '@simplywallst/ui-core';

export const IntroductionV2Wrapper = styled(Grid)`
  margin: ${({ theme }) => theme.x2spacePx}px 0px;
`;

export const RecentUpdatesWrapper = styled(Grid)`
  background: ${({ theme }) => theme.color.phantom};
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  padding: ${({ theme }) => theme.x2spacePx}px;
  width: 100%;
  height: 100%;
`;
